export default "__VITE_ASSET__2c2e88ad__"